/**
 * Fix hover images for Varia variant products
 * Runs after Varia changes the product cards to show correct variant hover images
 */

(function() {
  'use strict';

  function fixVariaHoverImages() {
    // Find all product cards on collection pages
    const productCards = document.querySelectorAll('.cgpt-card');
    
    productCards.forEach(card => {
      // Get the variant ID from the href (Varia sets this)
      const href = card.getAttribute('href');
      if (!href || !href.includes('variant=')) return;
      
      // Extract variant ID
      const variantId = href.split('variant=')[1].split('&')[0];
      
      // Get the parent li element which has the variant metafields data
      const productItem = card.closest('.cgpt-item');
      if (!productItem) return;
      
      // Get metafields data (we'll add this in Liquid)
      const metafieldsData = productItem.getAttribute('data-variant-hover-images');
      if (!metafieldsData) return;
      
      try {
        const metafields = JSON.parse(metafieldsData);
        
        // Check if this variant has a hover image metafield
        if (metafields[variantId]) {
          // Find the hover image element
          const hoverImg = card.querySelector('.is-hover');
          if (hoverImg) {
            let hoverImageUrl = metafields[variantId];
            
            // If the URL doesn't start with //, construct the full Shopify CDN URL
            if (!hoverImageUrl.startsWith('//') && !hoverImageUrl.startsWith('http')) {
              // Extract the filename from the metafield (e.g., "files/hastko_bra42_kaki-6.jpg")
              const filename = hoverImageUrl.replace('files/', '');
              // Use the same CDN pattern as other images on the site
              hoverImageUrl = `//hastko.com/cdn/shop/files/${filename}`;
            }
            
            // Update the hover image src
            hoverImg.src = hoverImageUrl;
            
            // Update srcset with different sizes
            const baseUrl = hoverImageUrl.split('?')[0];
            const extension = baseUrl.match(/\.(jpg|jpeg|png|gif|webp)$/i);
            if (extension) {
              const ext = extension[0];
              const baseWithoutExt = baseUrl.replace(ext, '');
              
              hoverImg.srcset = `
                ${baseWithoutExt}_360x${ext} 360w,
                ${baseWithoutExt}_540x${ext} 540w,
                ${baseWithoutExt}_720x${ext} 720w
              `.trim().replace(/\s+/g, ' ');
            }
          }
        }
      } catch (e) {
        console.error('Error parsing variant metafields:', e);
      }
    });
  }

  // Run after Varia and page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fixVariaHoverImages, 500);
    });
  } else {
    setTimeout(fixVariaHoverImages, 500);
  }

  // Also run when images are swapped (Varia might trigger this)
  document.addEventListener('variaImageSwap', fixVariaHoverImages);
  
  // Run periodically for a few seconds in case Varia is slow
  let attempts = 0;
  const interval = setInterval(function() {
    fixVariaHoverImages();
    attempts++;
    if (attempts >= 5) {
      clearInterval(interval);
    }
  }, 300);
})();